"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/CodeScreen.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _AuthFrame = require('web/components/AuthFrame');
var _Form = require('web/components/Form');

const CodeScreen = () => {
  const [codeVal, setCodeVal] = _react.useState.call(void 0, "")
  const [hasError, setHasError] = _react.useState.call(void 0, false)

  const updateVal = (nextCodeVal) => {
    setCodeVal(nextCodeVal)
    setHasError(!['v', 'w'].some(x => x === nextCodeVal[0]))
  }

  const submit = (e) => {
    e.preventDefault()
    // Keep this in sync with socket-server/webserver/care_server.go
    const firstVal = codeVal[0]

    if (firstVal === 'v') {
      location.hash = "video/" + codeVal
    } else if (firstVal === 'w') {
      location.hash = "welcome/" + codeVal.substring(1)
    } else setHasError(true)
  }

  return (
    _react2.default.createElement(_AuthFrame.AuthFrame, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
      , _react2.default.createElement('form', { className: "auth-stack", onSubmit: submit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
        , _react2.default.createElement('h1', { className: "auth-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}, "Welcome to BloomText"  )
        , _react2.default.createElement('p', { className: "auth-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}, "Please enter your code below."    )
        , _react2.default.createElement(_Form.InputSectionWrapper, {
          title: "Code",
          errorMessage: hasError
            ? 'That looks like an invalid code - please try again.'
            : ''
          , __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}

          , _react2.default.createElement(_Form.TextInput, {
            autoFocus: true,
            value: codeVal,
            hasError: hasError,
            onChange: e => updateVal(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
          )
        )
        , _react2.default.createElement(_Form.Button, { isSubmit: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}, "Go")
        , _react2.default.createElement('div', { className: "auth-links", __self: this, __source: {fileName: _jsxFileName, lineNumber: 46}}
          , _react2.default.createElement('a', { href: "/", className: "auth-link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}, "Back to BloomText"  )
        )
      )
    )
  )
}

exports. default = CodeScreen
